<template>
    <div class="firm-specific-document loading-content-container">
        <div v-if="isLoading" class="loading-overlay d-flex justify-content-center pt-5">
            <csp-loading-indicator/>
        </div>
        <b-row v-if="!isLoading">
            <b-col cols="12">
                <csp-desktop-firm-specific-document-basedata
                    :form-context="initialFormContexts.firmSpecificDocumentBasedata"
                    is-creation-form/>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import FirmSpecificDocumentBasedata
        from '@desktop/components/firm/firmSpecificDocument/FirmSpecificDocumentBasedata.vue';
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';
    import FormContext from '@desktop/components/FormContext';
    import Container from '@services/Container';

    const container = Container.getInstance();
    const firmRepository = container.getDesktopFirmRepository();

    export default {
        name: 'FirmSpecificDocumentCreate',
        components: {
            'csp-desktop-firm-specific-document-basedata': FirmSpecificDocumentBasedata,
        },
        mixins: [FormDataMixin],
        data() {
            const firmId = this.$route.params.firmId;

            return {
                firmId,
                isLoading: true,
                initialFormContexts: {
                    firmSpecificDocumentBasedata: new FormContext({
                        name: 'firmSpecificDocumentBasedata',
                        handleEditModeByQuery: false,
                        isInEditMode: true,
                    }),
                },
            };
        },
        created() {
            const loadFunction = () => {
                return firmRepository.getBlankFirmSpecificDocument(this.firmId);
            };
            this.loadFormData(loadFunction).finally(() => {
                this.isLoading = false;
            });
        },
    }
</script>
